import { Injectable } from '@angular/core';
import { Observable, Observer, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutingVariablesService {
  private yourData;
  private modulo;
  private resultado;
  private token = new Subject <any>();
  private usuario = new Subject <any>();
  private userData;
  
//// Metodos para enviar si es visitante, instructor, admin o usuario

  sendToken(token: string) {
    this.token.next({token: token})
  }

  clearToken() {
    this.token.next();
  }

  getToken(): Observable<any> {
    return this.token.asObservable();
  }
  ////////////////////////////////////////

  //// Metodos para enviar usuario

  sendUsuario(usuario: any) {
    this.usuario.next({usuario: usuario})
  }

  clearUsuario() {
    this.usuario.next();
  }

  getUsuario(): Observable<any> {
    return this.usuario.asObservable();
  }
  /////////////////////////////////////

  pushData(obj) {
    this.yourData = obj;
  }


  getData() {
    return this.yourData
  }

  seleccionarModulo(idx){
    this.modulo = idx;
  }

  getModulo() {
    return this.modulo;
  }

  pushResultado(obj) {
    this.resultado = obj
  }

  recibirResultado() {
    return this.resultado
  }

  pushUserData(user) {
    this.userData = user
  }

  getUserData() {
    return this.userData
  }

}
